import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { AuthContext } from "../../../../context/authContext";
import {
  attrArrayToMap,
  getCountryCode,
  getLocalPhoneNumber,
} from "../../../../helpers/utils";
import PhoneInputField from "../../../molecules/formControls/inputField/PhoneInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import ChangePhoneNumberValidation from "./validation";

const ChangePhoneNumberForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);
  const attrMap = attrArrayToMap(authContext.attrInfo);
  const countryCode = getCountryCode();

  const formik = useFormik({
    initialValues: {
      phone_number: getLocalPhoneNumber(attrMap, countryCode),
    },
    validationSchema: ChangePhoneNumberValidation(t, countryCode),
    onSubmit,
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-4"
    >
      <PhoneInputField
        id="phone_number"
        name="phone_number"
        required={true}
        onChange={formik.handleChange}
        countryCode={countryCode}
        onBlur={formik.handleBlur}
        value={formik.values.phone_number}
        formikTouched={formik.touched.phone_number}
        error={formik.errors.phone_number}
      />
      <DefaultButton
        type="submit"
        label={t("changeProfile.submit")}
        disabled={!(formik.isValid & formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default ChangePhoneNumberForm;
